import React from 'react';
import Card from '../atoms/card/Card';
import CompanyNames from '../../constants/companyNames';
import Anchor from '../atoms/anchor/Anchor';
import './SignupLoginCopy.sass';

export default function SignupLoginCopy() {
	return (
		<Card white noPaddingDesktop className="signup-login-header">
			<h1>Bank of America</h1>
			<h2>Sponsorships supporting communities</h2>
			<br />
			<p>Thank you for your interest in submitting a sponsorship proposal to {CompanyNames.boa}.</p>
			<p>
				{CompanyNames.boa} welcomes your sponsorship proposal for opportunities that make our communities a
				better place to live and work. We are particularly interested in providing support to address needs
				vital to the health of our communities through a focus on: preserving neighborhoods; educating the
				workforce for 21st century jobs; addressing critical needs such as hunger and emergency shelter; arts
				and culture; the environment; and diversity and inclusion programs.
			</p>
			<p>
				NOTE: If you are a 501(c)(3) nonprofit organization and wish to learn more about grant opportunities
				through the {CompanyNames.boa} Charitable Foundation, please log on to{' '}
				<Anchor
					id={`login-link-foundation`}
					data-link-num={2000}
					className="d-inline"
					target="_blank"
					href="http://www.bankofamerica.com/foundation"
					aria-label={`Visit the Bank of America Charitable Foundation website`}
				>
					bankofamerica.com/foundation
				</Anchor>. Grants are made at the Foundation’s discretion based on our current funding strategies
				focused on housing, jobs and hunger. Foundation grant requests should not include requests for payments
				in exchange for tangible benefits. Tangible benefits may include but are not limited to tickets, gifts,
				product placement, etc.
			</p>
		</Card>
	);
}
